import { render, staticRenderFns } from "./purchasepayement.vue?vue&type=template&id=7812e0b0&"
import script from "./purchasepayement.vue?vue&type=script&lang=js&"
export * from "./purchasepayement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports